const styles = (isMobile) => ({
  container: {
    fontFamily: "Inter Tight",
  },
  header: {
    padding: isMobile ? "4vh 5vw 2vh" : "4vh 2vw 2vh",
    background:
      "linear-gradient(180deg, rgba(255, 162, 162, 0.30) 0%, rgba(255, 255, 255, 0.00) 100%)",
  },
  headerContent: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "30px",
  },
  idText: {
    fontSize: "12px",
    color: "#0D0D0E",
  },
  idLabel: {
    color: "#949DAA",
    fontSize: "14px",
  },
  statusContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px",
  },
  statusCircle: {
    width: "20px !important",
    height: "20px !important",
    borderRadius: "50% !important",
    border: "5px solid #fff !important",
  },
  milestoneStatusCircle: {
    width: "15px !important",
    height: "15px !important",
    borderRadius: "50% !important",
    border: "3px solid rgb(229, 229, 229) !important",
  },
  statusText: {
    fontSize: "14px",
    color: "#0D0D0E",
  },
  subContainer: {
    padding: isMobile ? "1rem 2rem" : "2vh 2vw",
  },
  startDate: {
    fontSize: isMobile ? "12px" : "14px",
    color: "#0D0D0E",
  },
  endDate: {
    fontSize: isMobile ? "12px" : "14px",
    color: "#949DAA",
  },
  projectHeading: {
    color: "#0D0D0E",
    fontSize: isMobile ? "15px" : "22px",
    fontWeight: "500",
  },
  rowFlex: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  columnFlex: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  price: {
    color: "#0D0D0E",
    fontSize: "18px",
    fontWeight: "500",
  },
  greyRow: {
    color: "#949DAA",
    marginBottom: "2px",
    fontWeight: "500",
  },
  milestoneBtn: {
    borderRadius: "4px",
    background: "#4D6BF6",
    padding: isMobile ? "1vh 3vw" : ".7vh .7vw",
    color: "#fff",
    border: "none",
    cursor: "pointer",
  },
  //Project Overview
  overview_section: {
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    alignItems: "flex-start",
    marginTop: "2vh",
    gap: isMobile ? "20px" : "50px",
  },
  section_1: {
    flex: !isMobile && 2,
    width: isMobile && "100%",
  },
  section_2: {
    flex: 1,
    width: isMobile && "100%",
  },
  section_heading: {
    color: "#0D0D0E",
    fontSize: isMobile ? "14px" : "16px",
    fontWeight: "500",
  },
  section_sub_heading: {
    color: "#949DAA",
    fontSize: isMobile ? "12px" :"14px",
    fontWeight: "500",
  },
  infoGrid: {
    display: "grid",
    gridTemplateColumns: isMobile ? "repeat(2, 1fr)" : "repeat(3, 1fr)",
    gap: "20px",
    marginTop: "2vh",
  },
  name: {
    color: "#0D0D0E",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontsize: "14px",
    fontWeight: 600,
  },
  location: {
    borderRadius: "12px",
    background: "#F7F7F7",
    padding: "1vh 1vw",
  },
  stats_section: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    boxShadow: "none",
    borderRadius: 0,
    borderBottom: "1px solid #D7D8D9",
    paddingBottom: 0,
    alignItems: "flex-end",
  },
  stats_label: {
    marginBottom: "1vh",
    letterSpacing: "0",
    fontSize: "14px",
    color: "#949DAA",
  },
  stats_value: {
    fontSize:  "16px",
    color: "#0D0D0E",
    fontWeight: "500",
  },
  //budgetitem
  budget_item_heading: {
    color: "#0D0D0E",
    fontSize: "18px",
    fontWeight: "500",
    textTransform: "capitalize",
  },
  budget_item_text: {
    color: "#949DAA",
    fontSize: "14px",
    fontWeight: "500",
  },
  budget_item_amount_div: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: "18px",
    color: "#0D0D0E",
    marginTop: "1vh",
  },
  modal_heading: {
    color: " #0D0D0E",
    fontSize: "24px",
    fontWeight: "500",
  },
  modal_desc: {
    color: "#949DAA",
    fontSize: "14px",
    fontWeight: "500",
  },
  modal_value: {
    color: "#0D0D0E",
    fontSize: "14px",
    fontWeight: "600",
  },
  //status rounded
  status_pill: {
    borderRadius: "34px",
    padding: "4px 8px",
    fontSize: "14px",
    minWidth: "7ch",
    width: "fit-content",
    border: "none",
    textAlign: "center",
  },
});

export default styles;
